module.exports = __webpack_public_path__ + "dc5e3eff8ce2a6597b03d516d276e4d7.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/ebelev.png
// module id = 2386
// module chunks = 0